import { render, staticRenderFns } from "./PopupModal.vue?vue&type=template&id=2f24c72e&scoped=true&"
import script from "./PopupModal.vue?vue&type=script&lang=ts&"
export * from "./PopupModal.vue?vue&type=script&lang=ts&"
import style0 from "./PopupModal.vue?vue&type=style&index=0&id=2f24c72e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f24c72e",
  null
  
)

export default component.exports